/** Substring from API middleware requirePhAdmin (403). */
const PH_ADMIN_ACCESS_MESSAGE = "PH Admin access required";

/**
 * True when the server rejected the call because the user is not PH Admin.
 * Relies on `err.status` from phappsRequest (403) and/or the stable message body.
 */
export function isPhAdminAccessDenied(err) {
  if (!err) return false;
  if (err.status === 403) return true;
  const m = String(err.message || "");
  return m.includes(PH_ADMIN_ACCESS_MESSAGE);
}

/**
 * User-facing copy for admin dashboard / admin chemist API failures.
 */
export function getAdminApiErrorMessage(err, fallback = "Request failed") {
  if (isPhAdminAccessDenied(err)) {
    return "You don't have PH Admin access. This area is only available to authorised head-office administrators.";
  }
  if (typeof err?.message === "string" && err.message.trim()) {
    return err.message;
  }
  return fallback;
}
